import { ATTRIBUTE_TYPES } from '@yandex-int/k-common/constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../old-button/old-button';
import Text from '../text/text';

import BoolFilter from './attribute-filter_type_bool';
import EnumFilter from './attribute-filter_type_enum';
import NumberFilter from './attribute-filter_type_number';
import { attributeFilterPropType } from './utils';

import './attribute-filter.scss';

export const filterTypeMap = {
    [ATTRIBUTE_TYPES.BOOL]: BoolFilter,
    [ATTRIBUTE_TYPES.NUMERIC]: NumberFilter,
    [ATTRIBUTE_TYPES.ENUM]: EnumFilter,
    [ATTRIBUTE_TYPES.MULTIPLE_ENUM]: EnumFilter,
};

class AttributeFilter extends React.Component {
    static propTypes = {
        applyFilterFromUrl: PropTypes.func.isRequired,
        availableFilters: PropTypes.arrayOf(attributeFilterPropType),
        changeFilterValue: PropTypes.func.isRequired,
        clearFilters: PropTypes.func.isRequired,
        filters: PropTypes.arrayOf(attributeFilterPropType),
        filterValues: PropTypes.object,
        getAttributesRequest: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        mix: PropTypes.string,
        shouldShowClearButton: PropTypes.bool,
        getShouldReloadAttributes: PropTypes.func,
        themeId: PropTypes.number.isRequired,
    };

    static defaultProps = {
        getShouldReloadAttributes: (prevProps, props) => prevProps.themeId !== props.themeId,
    };

    componentDidMount() {
        const { applyFilterFromUrl, history, getAttributesRequest, themeId } = this.props;

        getAttributesRequest(themeId, { showAll: true });
        applyFilterFromUrl(history, themeId);
    }

    componentDidUpdate(prevProps) {
        const {
            clearFilters,
            getAttributesRequest,
            getShouldReloadAttributes,
            history,
            themeId: nextThemeId,
        } = this.props;

        if (getShouldReloadAttributes(prevProps, this.props)) {
            clearFilters(history, nextThemeId);

            getAttributesRequest(nextThemeId, { showAll: true });
        }
    }

    handleFilterChange = (filterSlug, filterValue) => {
        const { changeFilterValue, history, themeId } = this.props;

        changeFilterValue(filterSlug, filterValue, { history, themeId });
    };

    handleClearFilters = () => {
        const { clearFilters, history, themeId } = this.props;

        clearFilters(history, themeId);
    };

    render() {
        const { availableFilters, filters, mix, filterValues, shouldShowClearButton } = this.props;

        const className = cx('attribute__filters', mix);

        return (
            <div className={className}>
                {shouldShowClearButton && (
                    <Button mix="attribute__clear-filters" onClick={this.handleClearFilters} view="link">
                        <Text id="attributeFilters.clear" />
                    </Button>
                )}
                {filters.map((filter) =>
                    React.createElement(filterTypeMap[filter.typeSlug], {
                        available: availableFilters.find(({ slug }) => filter.slug === slug),
                        filter,
                        key: filter.slug,
                        value: filterValues[filter.slug],
                        onChange: (value) => this.handleFilterChange(filter.slug, value),
                    })
                )}
            </div>
        );
    }
}

export default AttributeFilter;
